import React from 'react';
import PageMeta from 'src/components/organisms/page-meta';
import { LandingBottomBannerContainer } from '../banner/containers/landing-bottom-banner-container';
import { LandingTopBannerContainer } from '../banner/containers/landing-top-banner-container';
import { TrendingNftsContainer } from '../collectible/containers/trending-nfts-container';
import { HighlightedCollectionsContainer } from '../collection/containers/highlighted-collections-container';
import { TopCollectionsContainer } from '../collection/containers/top-collections-container';
import { HighlightedQuestions } from '../faq/containers/highlighted-questions';
import { LandingPageLayout } from './s7-landing.styles';

const S7Landing = () => (
    <>
        <PageMeta title="Homepage" />
        <LandingTopBannerContainer />
        <LandingPageLayout>
            <HighlightedCollectionsContainer />
            <TopCollectionsContainer />
            <TrendingNftsContainer />
            <HighlightedQuestions />
        </LandingPageLayout>
        <LandingBottomBannerContainer />
    </>
);

export default S7Landing;
